import React from "react";
import NestedPage from "../../components/navigation/NestedPage";
import { nestedGroups } from "../../config/navigation";

const AdminPage: React.FC = () => {
  const adminGroup = nestedGroups.find((group) => group.id === "admin");

  if (!adminGroup) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-gray-500">Admin group not found.</p>
      </div>
    );
  }

  return <NestedPage group={adminGroup} />;
};

export default AdminPage;
